import { render, staticRenderFns } from "./addProvider.vue?vue&type=template&id=50e58cb5&scoped=true&"
import script from "./addProvider.vue?vue&type=script&lang=ts&"
export * from "./addProvider.vue?vue&type=script&lang=ts&"
import style0 from "./addProvider.vue?vue&type=style&index=0&id=50e58cb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e58cb5",
  null
  
)

export default component.exports